//+++++++++++++++++++++++++++++++++++++++++++++++
// ACCORDIONS
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class helps toggling content accordions
// visible
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.Accordion = function(accordion, accordionBody, toggleLink, toggleCloseLink) {
  this.accordion = accordion;
  this.accordionBody = accordionBody;
  this.toggleLink = toggleLink;
  this.toggleCloseLink = toggleCloseLink;
  this.accordion.classList.add("accordion--init");
  this.toggleLink.addEventListener('click', this.toggleAccordion.bind(this));
  this.toggleCloseLink.addEventListener('click', this.toggleAccordion.bind(this));
  this.animationDuration = 500;

  this.blockParent = closest(this.accordion, '.block');
  this.blockParent.classList.add('accordion-parent');
};

DW.Accordion.prototype = {
  toggleAccordion : function(ev) {
    ev.preventDefault();
    this.toggleLink.blur();

    // Check if other accordion is currently open
    var closeOtherAccordion = document.querySelector(".accordion.accordion--active");
    if(closeOtherAccordion && closeOtherAccordion != this.accordion) {
      closeOtherAccordion.classList.remove('accordion--active');
    }

    this.animateAccordion();
  },

  animateAccordion : function() {
    var to,
    start,
    callback = null,
    fps = 60,
    change,
    increment = 1000 / fps,
    elem = this.accordionBody;
    if(this.accordion.classList.contains('accordion--active')) {

      // Animate from height to zero, than remove display block class
      start = parseInt(this.accordionBody.style.height);
      to = 0;
      callback = function() {
        this.accordionBody.style.height = '';
        this.accordion.classList.remove('accordion--active');
      }.bind(this);
    } else {

      // Add display block class, than animate from zero to height
      this.accordion.classList.add('accordion--active');
      start = 0;
      to = this.accordionBody.offsetHeight;
      this.accordionBody.style.height = start;
    }

    change = to - start;

    var doOnIncrement = function(val) {
      elem.style.height = val + 'px';
    };

    var animate = new DW.Animate(this.animationDuration, increment, '', start, change, doOnIncrement, callback);
  }
};
